
import React from "react";
import { Button, ButtonProps } from "@/components/ui/button";
import { supabase } from "@/integrations/supabase/client";
import { useNavigate } from "react-router-dom";

interface SignupButtonProps extends ButtonProps {}

const SignupButton: React.FC<SignupButtonProps> = (props) => {
    const navigate = useNavigate();

  return (
    <Button
      size="sm"
      className={`rounded-full px-5 ${props.className || ""}`}
      onClick={() => navigate("/signup")}
      {...props}
    >
      Sign up
    </Button>
  );
};

export default SignupButton;
